export enum TrafficRequestStatusEnum {
  AWAITING = "AWAITING",
  REJECTED = "REJECTED",
  ACCEPTED = "ACCEPTED",
  EXPIRED = "EXPIRED",
  DELETED = "DELETED",
  APPLIED = "APPLIED"
}